export default __webpack_public_path__ + "static/media/cucumber.e8959fe8.jfif";